export const locales = ['da-dk', 'nl-nl', 'en', 'en-gb', 'fr', 'de', 'it-it', 'nb-no', 'pl-pl', 'pt-pt', 'pt-br', 'es', 'es-mx', 'sv-se'] as const;

export type Locale = (typeof locales)[number];
